<template>
  <div id="Account_User">
    <!-- 編輯個人帳號 -->
    <div
      id="huser"
      class="table-style fade show"
      role="tabpanel"
      aria-labelledby="hau"
    >
      <!-- 權限申請單 -->
      <div
        class="col-12 pt-3 pb-4"
      >
        <v-button
          class="mt-1"
          title="權限申請單列印"
          btn-text="權限申請單"
          btn-type="warning"
          @click.native="CheckApply"
        >
          <font-awesome-icon
            slot="icon"
            icon="print"
            size="sm"
          />
        </v-button>
      </div>
      <!-- 帳號資訊 -->
      <div class="col-12 pt-3 pb-4">
        <div class="form-row">
          <div class="form-group col-md-3">
            <v-label
              for="UserId"
              LabText="帳號ID"
              Labbold="true"
            />
            <input
              id="UserId"
              class="form-control"
              type="text"
              v-model="EditData.UserId"
              readonly
            >
          </div>
          <div class="form-group col-md-3">
            <v-small />
            <v-label
              for="UserName"
              LabText="姓名"
              Labbold="true"
            />
            <input
              id="UserName"
              class="form-control"
              type="text"
              placeholder="請填寫您的大名"
              v-model="EditData.UserName"
              required
            >
          </div>
        </div>
        <div class="form-row">
          <div class="form-group col-md-3">
            <v-small />
            <v-label
              for="Email"
              LabText="聯絡信箱"
              Labbold="true"
            />
            <input
              id="Email"
              class="form-control"
              type="email"
              v-model="EditData.Email"
              required
            >
          </div>
          <div class="form-group col-md-3">
            <v-small />
            <v-label
              for="Telephone"
              LabText="聯絡電話"
              Labbold="true"
            />
            <input
              id="Telephone"
              class="form-control"
              type="tel"
              v-model="EditData.Telephone"
              required
            >
          </div>
        </div>
        <div class="form-row pb-2">
          <div class="form-group col-md-3">
            <v-label
              for="Address"
              LabText="聯絡地址"
              Labbold="true"
            />
            <input
              id="Address"
              class="form-control"
              type="text"
              v-model="EditData.Address"
              required
            >
          </div>
          <div class="form-group col-md-3">
            <v-label
              for="Unino"
              LabText="部門"
              Labbold="true"
            />
            <input
              id="Unino"
              class="form-control"
              type="tel"
              v-model="EditData.DeptDesc"
              readonly
            >
          </div>
        </div>
        <div class="form-row pb-2">
          <v-label
            for="Telephone"
            LabText="需要收據(是/否)"
            Labbold="true"
          />
          <div style="margin-left: 30px;">
          <input
            id="ModifyNeedReceipt1"
            class="form-check-input"
            type="radio"
            v-model.number="EditData.NeedReceipt"
            value="0"
          >
          <v-label
            for="ModifyNeedReceipt1"
            class="form-check-label"
            lab-text="不需要"
          />
        </div>
          <div style="margin-left: 30px;">
          <input
            id="ModifyNeedReceipt2"
            class="form-check-input"
            type="radio"
            v-model.number="EditData.NeedReceipt"
            value="1"
          >
          <v-label
            for="ModifyNeedReceipt2"
            class="form-check-label"
            lab-text="需要"
          />
        </div>
        </div>
        <v-button
          title="更新"
          btn-text="更新"
          btn-type="primary"
          @click.native="PostAccountModify"
        />
      </div>
    </div>
  </div>
</template>

<script>
import $ from 'jquery'
import md5 from 'js-md5'
import vSmall from '@/components/Features/Small'
import vLabel from '@/components/Features/Label'
import { apiPrivilegeQuery, apiPrivilegeModify } from '../../Api/api'
export default {
  components: {
    vLabel,
    vSmall
  },
  data () {
    return {
      Allow: null,
      Identity: '',
      EditData: {},
      Backend: false
    }
  },
  mounted () {
    this.user()
    this.PostAccountQuery()
  },
  methods: {
    user () { // 判斷帳號權限
      const Data = sessionStorage.getItem('Backend')
      const admin = md5('業務')
      if (Data === admin) {
        this.Backend = false
      } else {
        this.Backend = true
      }
    },
    PostAccountQuery () { // 查詢 B_API 003
      // 定義資料
      const vm = this
      const UserData = JSON.parse(sessionStorage.getItem('UserData'))
      const NewData = JSON.parse(sessionStorage.getItem('Identity'))
      NewData.DeptId = UserData.DeptId
      NewData.QueryUserId = UserData.UserId
      // 呼叫API
      apiPrivilegeQuery(NewData).then(
        res => {
          if (res !== undefined) {
            vm.EditData = res.Data[0]
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    PostAccountModify () { // 變更 F_API 002
      // 定義資料
      const vm = this
      const NewEditData = JSON.parse(sessionStorage.getItem('Identity'))
      const NewUserData = JSON.parse(sessionStorage.getItem('UserData'))
      NewEditData.ModifyUserId = vm.EditData.UserId
      NewEditData.ModifyUserName = vm.EditData.UserName
      NewEditData.ModifyEmail = vm.EditData.Email
      NewEditData.ModifyTelephone = vm.EditData.Telephone
      NewEditData.ModifyAddress = vm.EditData.Address
      NewEditData.ModifyUnino = vm.EditData.Unino
      NewEditData.ModifyNeedReceipt = vm.EditData.NeedReceipt
      NewEditData.OriDeptId = NewUserData.DeptId
      NewEditData.ModifyDeptId = ''
      // Email防呆
      if (NewEditData.ModifyEmail === '') {
        vm.$bus.$emit('Modals', '聯絡信箱為必填欄位。')
        $('#CheckError').modal('show')
        return false
      }
      if (NewEditData.ModifyTelephone === '') {
        vm.$bus.$emit('Modals', '聯絡電話為必填欄位。')
        $('#CheckError').modal('show')
        return false
      }
      if (NewEditData.ModifyUserName === '') {
        vm.$bus.$emit('Modals', '姓名為必填欄位。')
        $('#CheckError').modal('show')
        return false
      }
      // 呼叫API
      apiPrivilegeModify(NewEditData).then(
        res => {
          if (res !== undefined) {
            vm.$bus.$emit('Modals', '資料已更新')
            $('#CheckOk').modal('show')
            vm.PostAccountQuery()
          } else {
            $('#CheckError').modal('show')
          }
        }
      )
    },
    CheckApply () {
      const UserData = JSON.parse(sessionStorage.getItem('UserData'))
      const data = UserData.UserId
      this.$router.push({ name: 'Admin_Access_Request', params: { id: data, type: 'change', again: 'false' } }) // 導向 權限申請頁面
    }
  }
}
</script>
